import * as React from "react";
import useSWR from "swr";
import { fetcher } from "../../../hooks";

export function useUserInfluencers(influencerId) {
  const { data, error, mutate } = useSWR(
    `/api/userInfluencer?influencer_id=${influencerId}`,
    fetcher,
  );

  const userInfluencers = React.useMemo(() => {
    if (!Array.isArray(data?.user_influencers)) {
      return [];
    }

    return data.user_influencers;
  }, [data]);

  return {
    error,
    isError: Boolean(error),
    isLoading: !error && !data,
    refresh: mutate,
    userInfluencers,
  };
}

export function useUserSearch(email) {
  const { data, error } = useSWR(
    email && email.trim().length >= 4
      ? `/api/user?email=${encodeURIComponent(email.trim())}`
      : null,
    fetcher,
  );

  return {
    users: Array.isArray(data) ? data : [],
    isLoading: email && email.trim().length >= 4 && !error && !data,
    isError: Boolean(error),
  };
}
